import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { isProduction } from 'parog-web/utils/runtime-environment';
export interface Signature {
    Element: HTMLAnchorElement;
    Blocks: {
        default: [];
    };
}
export default class TestEnvFeatureComponent extends Component<Signature> {
    get isTestEnv(): boolean {
        return !isProduction();
    }
    static{
        template(`
    {{#if this.isTestEnv}}
      {{yield}}
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
